(function () {
  function initHero(root) {
    const hero = root.querySelector('.spainho-hero');
    if (!hero || hero.dataset.motionReady === 'true') return;
    hero.dataset.motionReady = 'true';

    const button = hero.querySelector('.spainho-hero__motion');
    const label = hero.querySelector('.spainho-hero__motion-label');
    const mobile = window.matchMedia('(max-width: 749px)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let inView = true;
    let manuallyPaused = false;

    function activeVideo() {
      return hero.querySelector(mobile.matches ? '.spainho-hero__video--mobile' : '.spainho-hero__video--desktop');
    }

    function updateButton(isPlaying) {
      button.hidden = false;
      button.setAttribute('aria-label', isPlaying ? 'Pause background video' : 'Play background video');
      button.setAttribute('aria-pressed', String(!isPlaying));
      button.querySelector('[aria-hidden]').textContent = isPlaying ? 'Ⅱ' : '▶';
      label.textContent = isPlaying ? 'Pause video' : 'Play video';
    }

    function sync() {
      const current = activeVideo();
      hero.querySelectorAll('video').forEach(function (video) {
        if (video !== current) video.pause();
      });
      const shouldPlay = inView && !reduced.matches && !manuallyPaused;
      if (shouldPlay) {
        const promise = current.play();
        if (promise && promise.catch) promise.catch(function () { updateButton(false); });
      } else {
        current.pause();
      }
      updateButton(shouldPlay);
    }

    button.addEventListener('click', function () {
      manuallyPaused = !manuallyPaused;
      if (manuallyPaused) {
        activeVideo().pause();
        updateButton(false);
      } else {
        const promise = activeVideo().play();
        if (promise && promise.catch) promise.catch(function () { updateButton(false); });
        updateButton(true);
      }
    });

    mobile.addEventListener('change', sync);
    reduced.addEventListener('change', function () {
      if (reduced.matches) manuallyPaused = true;
      sync();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.12 }).observe(hero);
    }
    if (reduced.matches) manuallyPaused = true;
    sync();
  }

  function initAll(scope) {
    scope.querySelectorAll('.spainho-editorial').forEach(initHero);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
